import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getAllSubscriptionsAction = createAsyncThunk(
  "subscriptions/getAllSubscriptions",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.SUBSCRIPTIONS.GET_ALL
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getSubscriptionsWithFiltersAction = createAsyncThunk(
  "subscriptions/getSubscriptionsWithFilters",
  async (params = {}, thunkAPI) => {
    try {
      const { userId } = params;

      if (!userId) {
        return thunkAPI.rejectWithValue("User ID is required");
      }

      // Build query parameters with only userId
      const queryParams = new URLSearchParams({
        userId,
      });

      const url = `${
        API_ENDPOINTS.SUBSCRIPTIONS.GET_ALL
      }?${queryParams.toString()}`;
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getUserSubscriptionAction = createAsyncThunk(
  "subscriptions/getUserSubscription",
  async (uid, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.SUBSCRIPTIONS.GET_USER_SUBSCRIPTION(uid)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const createSubscriptionAction = createAsyncThunk(
  "subscriptions/createSubscription",
  async (subscriptionData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.SUBSCRIPTIONS.CREATE,
        subscriptionData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateSubscriptionAction = createAsyncThunk(
  "subscriptions/updateSubscription",
  async ({ subscriptionId, subscriptionData }, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.SUBSCRIPTIONS.UPDATE(subscriptionId),
        subscriptionData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const cancelSubscriptionAction = createAsyncThunk(
  "subscriptions/cancelSubscription",
  async (subscriptionId, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.SUBSCRIPTIONS.CANCEL(subscriptionId)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
